var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("dsf-dropdown-wrapper", {
    ref: "dropdownWrapper",
    staticClass: "el-select super-search-tree-select",
    staticStyle: { width: "100%" },
    attrs: { width: _vm.width },
    on: { "visible-change": _vm.visibleChange },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function () {
          return [
            !_vm.multipe
              ? _c(
                  "el-input",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { readonly: "", value: _vm.selectName },
                    nativeOn: {
                      mouseenter: function ($event) {
                        _vm.inputHovering = true
                      },
                      mouseleave: function ($event) {
                        _vm.inputHovering = false
                      },
                    },
                  },
                  [
                    _c("template", { slot: "suffix" }, [
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.showCloseCopy,
                            expression: "!showCloseCopy",
                          },
                        ],
                        class: [
                          "el-select__caret",
                          "el-input__icon",
                          "el-icon-" + _vm.iconClass,
                        ],
                      }),
                      _vm.showCloseCopy
                        ? _c("i", {
                            staticClass:
                              "el-select__caret el-input__icon el-icon-circle-close",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.handleClearClick.apply(
                                  null,
                                  arguments
                                )
                              },
                            },
                          })
                        : _vm._e(),
                    ]),
                  ],
                  2
                )
              : _vm._e(),
            _vm.multipe
              ? [
                  _c(
                    "div",
                    {
                      on: {
                        mouseenter: function ($event) {
                          _vm.inputHovering = true
                        },
                        mouseleave: function ($event) {
                          _vm.inputHovering = false
                        },
                      },
                    },
                    [
                      _c(
                        "el-input",
                        {
                          staticStyle: { width: "100%" },
                          attrs: { readonly: "" },
                        },
                        [
                          _c("template", { slot: "suffix" }, [
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.showCloseCopy,
                                  expression: "!showCloseCopy",
                                },
                              ],
                              class: [
                                "el-select__caret",
                                "el-input__icon",
                                "el-icon-" + _vm.iconClass,
                              ],
                            }),
                            _c("i", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showCloseCopy,
                                  expression: "showCloseCopy",
                                },
                              ],
                              staticClass:
                                "el-select__caret el-input__icon el-icon-circle-close",
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.handleClearClick.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            }),
                          ]),
                        ],
                        2
                      ),
                      _c(
                        "div",
                        {
                          ref: "tags",
                          staticClass: "el-select__tags",
                          style: { width: "100%" },
                        },
                        [
                          _vm.collapseTags
                            ? _c(
                                "span",
                                [
                                  _vm.item.treeNodeSelected.length > 0
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            title:
                                              _vm.item.treeNodeSelected[0]
                                                ._name,
                                            closable: true,
                                            size: "small",
                                            hit: false,
                                            type: "info",
                                            "disable-transitions": "",
                                          },
                                          on: {
                                            close: function ($event) {
                                              return _vm.deleteTag(
                                                $event,
                                                _vm.item.treeNodeSelected[0]
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-select__tags-text",
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.item.treeNodeSelected[0]
                                                    ._name
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm.item.treeNodeSelected.length > 1
                                    ? _c(
                                        "el-tag",
                                        {
                                          attrs: {
                                            closable: false,
                                            size: "small",
                                            type: "info",
                                            "disable-transitions": "",
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "el-select__tags-text",
                                            },
                                            [
                                              _vm._v(
                                                "+ " +
                                                  _vm._s(
                                                    _vm.item.treeNodeSelected
                                                      .length - 1
                                                  )
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              )
                            : _c(
                                "span",
                                _vm._l(
                                  _vm.item.treeNodeSelected,
                                  function (tag) {
                                    return _c(
                                      "el-tag",
                                      {
                                        key: tag._id,
                                        attrs: {
                                          title: tag._name,
                                          closable: true,
                                          size: "small",
                                          type: "info",
                                          "disable-transitions": "",
                                        },
                                        on: {
                                          close: function ($event) {
                                            return _vm.deleteTag($event, tag)
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          {
                                            staticClass: "el-select__tags-text",
                                          },
                                          [_vm._v(_vm._s(tag._name))]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                1
                              ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        },
        proxy: true,
      },
      {
        key: "dropdown",
        fn: function () {
          return [
            _c("dropdown-tree", {
              ref: "tree",
              attrs: {
                values: _vm.values,
                item: _vm.item,
                options: _vm.options,
                multipe: _vm.multipe,
              },
              on: { change: _vm.treeNodeChange },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }